import CONSTANTS from '../../constants'
import fetchWithAuthorizationHeader from '../../helper/fetchWithAuthorizationHeader'
import type { MongoDBRequest } from '../../types/mongodb'

const { MONGODB_API_URL } = CONSTANTS

const getSingleMongoDB = async (
	mongoDBID: string
): Promise<{ statusCode: number; body: MongoDBRequest[] }> => {
	const query = new URLSearchParams({ mongoDBID }).toString()
	const response = await fetchWithAuthorizationHeader(
		`${MONGODB_API_URL}?${query}`
	)
	const data = await response.json()
	if (!response.ok) {
		throw new Error(
			data.error?.message ||
				data.message ||
				'Unable to complete the MongoDB request.'
		)
	}
	if (!Array.isArray(data.body)) throw new Error('Invalid MongoDB response.')
	return data
}

export default getSingleMongoDB
